import { Box, Grid, TextField, MenuItem, Button } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import RefreshIcon from '@mui/icons-material/Refresh'
import { useState } from 'react'

export interface TransactionFiltersState {
  msisdn: string
  paybill: string
  status: string
  channel: string
  externalId: string
}

interface TransactionFiltersProps {
  onFilterChange: (filters: TransactionFiltersState) => void
}

const statusOptions = ['All', 'PENDING', 'COMPLETED', 'FAILED', 'CANCELLED']
const channelOptions = ['All', 'Online', 'SMS']

const defaultFilters: TransactionFiltersState = {
  msisdn: '',
  paybill: '',
  status: 'All',
  channel: 'All',
  externalId: '',
}

const TransactionFilters = ({ onFilterChange }: TransactionFiltersProps) => {
  const [filters, setFilters] = useState<TransactionFiltersState>(defaultFilters)

  const handleChange = (field: keyof TransactionFiltersState, value: string) => {
    const updated = { ...filters, [field]: value }
    setFilters(updated)
    onFilterChange(updated)
  }

  const handleReset = () => {
    setFilters(defaultFilters)
    onFilterChange(defaultFilters)
  }

  return (
    <Box component="form" sx={{ mb: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="MSISDN"
            value={filters.msisdn}
            onChange={(e) => handleChange('msisdn', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="Paybill"
            value={filters.paybill}
            onChange={(e) => handleChange('paybill', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            select
            fullWidth
            label="Status"
            value={filters.status}
            onChange={(e) => handleChange('status', e.target.value)}
          >
            {statusOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            select
            fullWidth
            label="Channel"
            value={filters.channel}
            onChange={(e) => handleChange('channel', e.target.value)}
          >
            {channelOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="External ID"
            value={filters.externalId}
            onChange={(e) => handleChange('externalId', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={1} sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            startIcon={<SearchIcon />}
            onClick={() => onFilterChange(filters)}
          >
            Filter
          </Button>
        </Grid>
        <Grid item xs={12} md="auto">
          <Button
            variant="outlined"
            color="inherit"
            startIcon={<RefreshIcon />}
            onClick={handleReset}
          >
            Reset
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default TransactionFilters

